"use client";

import styles from "./styles.module.scss";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import UnivoLink from "@/components/common/UnivoLink";

export interface FooterCity {
  slug: string;
  documentId: string;
}

interface FooterCityLinksProps {
  heading?: string;
  subHeading?: string;
  cities?: FooterCity[] | null;
  device?: string;
}

/** "navi-mumbai" -> "Navi Mumbai" */
const getCityName = (slug: string) =>
  slug
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const LocationIcon = () => (
  <svg
    width={32}
    height={40}
    viewBox="0 0 24 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 0C5.373 0 0 5.373 0 12c0 8.25 10.2 17.1 10.635 17.475a2.1 2.1 0 0 0 2.73 0C13.8 29.1 24 20.25 24 12 24 5.373 18.627 0 12 0Z"
      fill="#F5B82E"
    />
    <circle cx="12" cy="11.5" r="4.5" fill="#ffffff" />
  </svg>
);

export default function FooterCityLinks({
  heading = "Our Presence",
  subHeading = "Explore our programs in your city",
  cities,
  device,
}: FooterCityLinksProps) {
  const isDesktop = device === "desktop";

  const GAEventsHandler = (ctaText: string) => {
    pushToDataLayer({
      event: "footer_interaction",
      cta_text: ctaText,
      section_name: heading,
      page_type: getGlobalStateValue("pageType"),
    });
  };

  if (!cities?.length) return null;

  return (
    <section className={styles.root} aria-labelledby="footer-city-links-title">
      <div className={styles.intro}>
        <span className={styles.icon}>
          <LocationIcon />
        </span>
        <div>
          <h2 className={styles.heading} id="footer-city-links-title">
            {heading}
          </h2>
          <p className={styles.subHeading}>{subHeading}</p>
        </div>
      </div>

      <ul className={styles.cityList}>
        {cities.map((city) => {
          const cityName = getCityName(city.slug);
          return (
            <li key={city.documentId}>
              <UnivoLink
                isAnchor
                href={`/${city.slug}`}
                className={styles.cityChip}
                target={isDesktop ? "_blank" : undefined}
                rel={isDesktop ? "noopener noreferrer" : undefined}
                onClick={() => GAEventsHandler(cityName)}
              >
                {cityName}
              </UnivoLink>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
